import React from 'react';
import { Building2, Plus } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/components/ui/command';
import { LW_THEME_CLASS } from './shared/InvestorThemeScope';
import type { Investor } from '@/types/investor';

interface InvestorCommandPaletteProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  investors: Investor[];
  onSelectInvestor: (investor: Investor) => void;
  onAddInvestor?: () => void;
}

/**
 * ⌘K palette for Manage Investors v2. Composes Dialog + Command (the ui/command
 * primitives don't ship a CommandDialog). Fuzzy-searches investor name + AE name/email.
 */
export const InvestorCommandPalette: React.FC<InvestorCommandPaletteProps> = ({
  open, onOpenChange, investors, onSelectInvestor, onAddInvestor
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className={`${LW_THEME_CLASS} overflow-hidden rounded-xl p-0 sm:max-w-[580px]`}>
      <DialogTitle className="sr-only">Search investors</DialogTitle>
      <Command>
        <CommandInput placeholder="Search investors or AE…" />
        <CommandList>
          <CommandEmpty>No results found.</CommandEmpty>
          {onAddInvestor && (
            <CommandGroup heading="Actions">
              <CommandItem value="add new investor" onSelect={onAddInvestor}>
                <Plus className="mr-2 h-4 w-4" /> Add investor
              </CommandItem>
            </CommandGroup>
          )}
          <CommandGroup heading="Investors">
            {investors.map((inv) => (
              <CommandItem
                key={inv.id}
                value={`${inv.investor} ${inv.wholesaleAeName ?? ''} ${inv.correspondentAeName ?? ''} ${inv.wholesaleAeEmail ?? ''} ${inv.correspondentAeEmail ?? ''}`}
                onSelect={() => onSelectInvestor(inv)}
              >
                <Building2 className="mr-2 h-4 w-4" /> {inv.investor}
              </CommandItem>
            ))}
          </CommandGroup>
        </CommandList>
      </Command>
    </DialogContent>
  </Dialog>
);

export default InvestorCommandPalette;
